const classNames = require('classnames');

export const classes = (component: string, ...otherClassNames: (string | undefined)[]) =>
    classNames(`elc-${component}`, `js-${component}`, otherClassNames);
